/**
 * Removes duplicate objects from an array and sorts it based on datetimetext property.
 *
 * @param {Array} arr - The input array containing objects with datetimetext property.
 * @returns {Array} A new array with duplicates removed and sorted by datetimetext in descending order.
 */
export const removeDuplicatesAndSort = (arr) => {
  /**
   * An object to track unique objects based on their string representation.
   * @type {Object}
   */
  const uniqueObject = {};

  /**
   * An array to store the final unique and sorted objects.
   * @type {Array}
   */
  const uniqueArray = [];

  arr.forEach((obj) => {
    if (obj.headerText === "Connection Failed") {
      uniqueArray.push(obj); // Always add "Connection Failed" objects
    } else {
      const strObj = JSON.stringify(obj);
      if (!uniqueObject[strObj]) {
        uniqueObject[strObj] = true;
        uniqueArray.push(obj);
      }
    }
  });

  // Sort the uniqueArray by datetimetext
  // Use a flexible date parser since datetimetext may come in various formats
  uniqueArray.sort((a, b) => {
    const parseDate = (str) => {
      if (!str) return 0;
      // Try standard Date parse first (works for YYYY-MM-DD format)
      const d = new Date(str);
      if (!isNaN(d.getTime())) return d.getTime();
      // Fallback: try DD-MM-YYYY HH:mm:ss A format
      const parts = str.match(/(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})\s*(AM|PM)?/i);
      if (parts) {
        const [, dd, mm, yyyy, hh, min, ss, ampm] = parts;
        let hour = parseInt(hh, 10);
        if (ampm && ampm.toUpperCase() === "PM" && hour < 12) hour += 12;
        if (ampm && ampm.toUpperCase() === "AM" && hour === 12) hour = 0;
        return new Date(yyyy, mm - 1, dd, hour, min, ss).getTime();
      }
      return 0;
    };
    const timeA = parseDate(a.datetimetext);
    const timeB = parseDate(b.datetimetext);
    return timeB - timeA; // Sorting in descending order (newest first)
  });

  return uniqueArray;
};
